module.exports = __webpack_public_path__ + "assets/logo-white-de4eebf674570ca4ce888fec38e6c2aa.svg";